import application_contants from '../../contants/application_contants';

const FundermeetData = [
    
        application_contants.gizmeeting_1,
];

export default FundermeetData
